import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const About = () => {
  const [containerClass, setContainerClass] = useState("container");
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setContainerClass("container");
      } else {
        setContainerClass("");
      }
    };

    handleResize(); // run on first render
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <section className={`${containerClass} sub-bg pt-80`}>
      <div
        className="about__shape wow slideInLeft"
        data-wow-delay="400ms"
        data-wow-duration="1500ms"
      >
        <img src="/assets/images/shape/about-line.png" alt="shape" />
      </div>
      <div className="container">
        <div className="row g-4">
          <div
            className="col-xl-6 wow fadeInRight d-none d-sm-block"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            <motion.div
              animate={{ y: [0, -30, 0, 30, 0] }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              className="about__left-item"
            >
              <div className="image big-image">
                <img src="/assets/images/about/about-image1.png" alt="image" />
              </div>

              <div className="image sm-image">
                <div className="video__btn-wrp">
                  <div className="video-btn video-pulse">
                    <a
                      className="video-popup"
                      href="https://www.youtube.com/watch?v=iVqz_4M5mA0"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa-solid fa-play" />
                    </a>
                  </div>
                </div>
                <img src="/assets/images/about/about-image2.png" alt="image" />
              </div>

              <div className="circle-shape">
                <img src="/assets/images/shape/about-circle.png" alt="shape" />
              </div>
            </motion.div>
          </div>
          <div className="col-xl-6">
            <div className="section-header mb-40 mt-sm-0" style={{marginTop:-35}}>
              <h5
                className="wow fadeInUp fs-4"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
                style={{ textTransform: "capitalize" }}
              >
                <img
                  className="me-1 h-30 w-30 object-fit-cover"
                  src="/assets/images/icon/section-title.png"
                  alt="icon"
                />
                About Coempt
              </h5>
              {/* <h2
                className="wow fadeInUp"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                Digital Lab English Lab | Career Lab | Aptitude Lab
              </h2> */}
              <p
                className="wow fadeInUp family"
                data-wow-delay="400ms"
                data-wow-duration="1500ms"
              >
                Coempt Edu Teck is a leading EdTech company with over 25 years
                of progressive experience in providing end-to-end examination
                solutions to certificate awarding bodies. Our solutions like
                OneX, Onmark, EzyTest, and DigiTali are envisioned and
                meticulously developed to empower awarding bodies practice
                transparency and good governance in the assessment and
                examination space.
              </p>
            </div>
            <div
              className="d-flex flex-column flex-sm-row gap-2 wow fadeInDown"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
              style={{ width: "60vh" }}
            >
              <div className="d-flex flex-column gap-3 me-4">
                <div className="about__right-item">
                  <div className="icon ps-3 pe-3">
                    <img src="/assets/images/icon/about-icon1.png" alt="icon" />
                  </div>
                  <Link to="/oursolutions" className="content">
                    <h4
                      className="mb-1 "
                      style={{ whiteSpace: "nowrap", fontSize: "16px" }}
                    >
                      Our Solutions
                    </h4>
                    {/* <p>Scelerisque augue the consequat sodales</p> */}
                  </Link>
                </div>
              </div>
              <div className="d-flex flex-column gap-3">
                <div className="about__right-item">
                  <div className="icon ps-3 pe-3">
                    <img src="/assets/images/icon/about-icon2.png" alt="icon" />
                  </div>
                  <div className="content" id="callsupport">
                    <h4
                      className="mb-1"
                      style={{ whiteSpace: "nowrap", fontSize: "16px" }}
                    >
                      {" "}
                      Call Support
                    </h4>
                    {/* <p>Scelerisque augue the consequat sodales</p> */}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="about__info mt-50 wow fadeInDown"
              data-wow-delay="400ms"
              data-wow-duration="1500ms"
            >
              {/* <a to="about.html" className="btn-one">
                  Explore More <i className="fa-regular fa-arrow-right-long" />
                </a> */}
              <Link to="/management" className="btn-one">
                Our Management Team {"\u00a0"}
                <motion.i
                  className="fa-regular fa-arrow-right-long"
                  animate={{ x: [0, -10, 0] }}
                  transition={{
                    duration: 2,
                    ease: "linear",
                    repeat: Infinity,
                  }}
                />
              </Link>
              {/* <div className="d-flex gap-2 align-items-center">
                <img
                  src="management/img12.jpg"
                  alt="image"
                  style={{
                    height: 60,
                    width: 60,
                    objectFit: "contain",
                    borderRadius: 100,
                  }}
                />
                <div className="info">
                  <h5>V S N Raju</h5>
                  <span className="sm-font">CEO</span>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
